<div class="v2-button">
    <!-- Default -->
    <button mat-button *ngIf="variant === 'flat'" [color]="color" [ngClass]="{
        'bold': bold,
        'small-button': size === 'small-button',
        'medium-button': size === 'medium-button',
        'large-button': size === 'large-button'
        
    }" [disabled]="disabled">

        <div *ngIf="text">{{text}}</div>
        <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
    </button>

    <button mat-stroked-button *ngIf="variant === 'stroked'" [color]="color" [ngClass]="{
        'bold': bold,
        'small-button': size === 'small-button',
        'medium-button': size === 'medium-button',
        'large-button': size === 'large-button'
        
    }" [disabled]="disabled">

        <div *ngIf="text">{{text}}</div>
        
        <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
    </button>

    <button mat-raised-button *ngIf="variant === 'raised'" [color]="color" [ngClass]="{
        'bold': bold,
        'small-button': size === 'small-button',
        'medium-button': size === 'medium-button',
        'large-button': size === 'large-button'
    }" [disabled]="disabled">
        <div *ngIf="text">{{text}}</div>
        <mat-icon *ngIf="icon" [svgIcon]="icon"></mat-icon>
    </button>
</div>